<template>
  <IconLucideBookOpenText />
</template>
